import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableFulfillmentRates = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableFulfillmentRates);
};
